import { useContext, useState, useRef } from 'react';
import UIContext from '../../../contexts/ui/UIContext';
import Button from '../../layout/Button';
import ProcessContext from '../../../contexts/process/ProcessContext';
import PictureProcessingService, { REPORT_PICTURE_EXTENSIONS } from '../../../services/PictureProcessingService';

export const PictureUpload = ({ changeHandler, withPreview=false }) => {
  const { setLoading } = useContext(UIContext);
  const {notifyError} = useContext(ProcessContext);
  const inputRef = useRef(null);
  const [src, setSrc] = useState(null);

  // Handles click on the file upload button and "clicks" on the input element.
  const clickFileInput = () => {
    let input = document.getElementById('poca');
    input.click();
  };

  // Handles the file input change, reads the image and sends the base64 string to the parent component.
  const onInputChange = async (event) => {
    try {
      setLoading(true);

      const picture = await PictureProcessingService.readPictureFile(event.target.files?.[0], REPORT_PICTURE_EXTENSIONS);

      if (!picture.fileSelected) {
        return;
      }

      if (!picture.isValid) {
        notifyError(
          'The image you tried to upload has the wrong type. Please provide a JPG, PNG or HEIC image and try again.'
        );

        changeHandler(null);
        return;
      }

      setSrc(picture.photoData);

      changeHandler({
        photoData: picture.photoData,
      });
    } catch {
      notifyError('An error occurred while processing the image you uploaded.');
      changeHandler(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='file-select'>
      <Button className='upload-photo-btn' icon='fas fa-camera' label='Take Photo' clickHandler={clickFileInput} />
      <input ref={inputRef} type='file' id='poca' onChange={onInputChange} style={{display: 'none'}} />
      {withPreview && <img id='picture-upload-img' src={src ?? '.\\images\\default.png' } />}
    </div>
  );
}
